import { SortParams } from "store/common/types";
import { FiltersActions, ReportsFiltersArgs, REPORTS_FILTERS } from "./types";

const initialFilters = {
  groupId: -1,
  documentType: -1,
  timeFilterType: "ALL_TIME",
  dateRange: null,
  subordinatesFilter: "ALL_USERS",
  query: "",
};

const initialPaginationParams = {
  page: 0,
  size: 10,
  sort: ["name", "asc"] as SortParams,
};

const initialState: ReportsFiltersArgs = {
  filterParams: initialFilters,
  paginationParams: initialPaginationParams,
};

export function reportsFiltersReducer(
  state = initialState,
  action: FiltersActions
): ReportsFiltersArgs {
  const { response, type } = action;

  switch (type) {
    case REPORTS_FILTERS.SET:
      return { ...state, filterParams: response };

    case REPORTS_FILTERS.PARAMS_SET:
      return { ...state, paginationParams: response };

    default:
      return state;
  }
}
